export type { RichTextAreaWrapperProps } from './styled';
export { getRichTextAreaWrapperStyles } from './styled';
